import React, { useState, useRef, useEffect } from 'react'
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import Overlay from '../../Components/Overlay/Overlay';
import { registerUser, getUserIdentity } from "../../Services/RegisterService";
import { modena_login_bg } from '../../Images';
import Swal from 'sweetalert2';
import { toastError } from '../../Components/Toasts/Toast';
import { handlerFormError } from '../../Utils/Utils';
import { NavLink } from 'react-router-dom';

let procesingId = -1;

const RegisterPage = () => {
  const { register, handleSubmit, watch, control, setValue, formState: { errors }, reset } = useForm({ defaultValues: { role_id: 3, is_active: false } });

  const navigate = useNavigate();
  const [state, setState] = useState({
    user: {
      role: { _id : -1 }
    },
    roles: [],
    processing: false,
    email: '',
    emails: [],
    selectedEmail: null,
    isFocus: false,
    withPassword: true,
    file_icon: '',
  });

  const startProcessing = () => {
    procesingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  }

  const stopProcessing = () => {
    clearInterval(procesingId);
    setState({ ...state, processing: false });
  }

  const onChangeEmail = (e) => {
    const isMailModena = e.target.value.includes('@modena.com');
    if (isMailModena) {
      setState({ ...state, withPassword: false, email: e.target.value, isFocus: true });
    } else {
      setState({ ...state, withPassword: true, email: e.target.value, isFocus: true });
    }
  }

  const onSubmit = (data) => {

    if (isFocus) {
      toastError("You are inputed modena's email, please click email from list!");
      return;
    }

    data.avatar = user.file;
    const formData = new FormData();
    for (var key in data) {
      formData.append(key, data[key]);
    }

    formData.append('avatar', file_icon);

    startProcessing();
    const response = registerUser(formData);
    response.then(res => {
      if (res.status == 200 || res.status == 201) {
        Swal.fire({
          icon: 'success',
          title: 'Save data success',
          text: 'Data has been saved!'
        }).then(r => {
          onReset();
          navigate('/login')
        })
      }
    }).catch(({ response: { data } }) => {
      handlerFormError(data);
    }).finally(_ => stopProcessing());
  }

  const { user, roles, processing, withPassword, email, emails, isFocus, selectedEmail, file_icon } = state;


  useEffect(() => {
    if (email != '') {
      // const time = setTimeout(() => {
      //   getUserIdentity(email, ({ data }) => {
      //     if (data.total > 0) {
      //       var arr = [];

      //       data.data.map((item,i) => {
      //         if(item.employee_status === 'Active' && item.email.includes('@modena.com')){
      //           arr.push(item)
      //         }
      //       })

      //       setState({ ...state, emails: arr });
      //     } else {
      //       setState({ ...state, isFocus: false });
      //     }
      //   });
      // }, 150);

      // return () => clearTimeout(time);
    } else {
      setState({ ...state, emails: [], isFocus: false });
    }

  }, [email]);

  const onSelectEmail = (item) => {
    setState({ ...state, selectedEmail: item, isFocus: false, withPassword: false });
    setValue('email', item.email);
    setValue('nik', item.emp_no);
    setValue('full_name', item.employe_name);
    setValue('phone', item.phone);
    setValue('employee_position', item.employee_position);
    setValue('organization_unit', item.organization_unit);
    setValue('job_title', item.job_title);
    setValue('job_status', item.job_status);
    setValue('work_location', item.work_location);
    setValue('cost_center', item.cost_center);
    setValue('username', item.email.replace('@modena.com', ''));
    setValue('role_id', 2);
    setValue('role_name', 'Guest');
  };

  const onReset = () => {
    setState({ ...state, email: '', emails: [], selectedEmail: null, withPassword: true, isFocus: false, file_icon: '', user: {role: { _id : -1 }} })
    reset({
      email: '',
      nik: '',
      full_name: '',
      phone: ''
    });
  }

  return (
    <div className='login-container' style={{ height: '100vh' }}>
      <div className='bg-login d-flex justify-content-center align-items-center' style={{ backgroundImage: `url(${modena_login_bg})`, backgroundSize: 'cover', backgroundPosition: 'center center' }}></div>
      <div className='login-form' style={{}}>
        <div className='d-flex' style={{ height: '100%', flexDirection: 'column', justifyContent: "center" }}>
        <Overlay display={processing} />
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='row' style={{ width: '100%' }}>
              <div className='col-1'></div>
              <div className='col-10'>
                <div className='form-group mb-3'>
                  <h1 style={{ color: '#777' }}>Register</h1>
                  <h4 style={{ color: '#777', fontSize: 18, fontWeight: 400, marginBottom: 20 }}>Digital Assets Bank</h4>
                </div>
                <div className='form-group'>
                  <label htmlFor='email' className='mandatory'>Email</label>
                  <div style={{ border: 'solid 1px #ccc', borderRadius: 4 }}>
                    <input id="email" {...register('email', { 
                      onChange: onChangeEmail,
                      email: { value: true, message: 'Invalid email!' },
                      required: { value: true, message: 'Email is required' } 
                    })} className='inputLogin' type="email" autoComplete='off'/>
                  </div>
                  {errors.email && <span className='text-danger'>{errors.email.message}</span>}

                  {emails.length > 0 && isFocus &&
                    <div className='mt-1 p-2' style={{ zIndex: 1, position: 'absolute', background: '#fff', border: '1px solid #ccc', borderRadius: 5, width: '22.5%' }}>
                      {
                        emails.map((item, i) =>
                          <div onClick={() => onSelectEmail(item)} key={i} className='d-flex align-items-center w-100 p-1 mb-1' style={{ border: '1px solid #ccc', borderRadius: 5, cursor: 'pointer' }}>
                            <span className='ml-2'>{item.email}</span>
                          </div>
                        )
                      }
                    </div>
                  }
                </div>
                {/* <div className='form-group'>
                  <label htmlFor='nik' className='mandatory'>NIK</label>
                  <input id="nik" {...register("nik", { required: 'NIK is required!' })} className='form-control' readOnly={true} />
                  {errors.nik && <span className='text-danger'>{errors.nik.message}</span>}
                </div> */}
                <div className='form-group'>
                  <label htmlFor='username' className='mandatory'>User Name</label>
                  <input id="username" {...register("username", { required: 'Username is required!' })} className='form-control' readOnly={false} />
                  {errors.username && <span className='text-danger'>{errors.username.message}</span>}
                </div>
                {/* <div className='form-group'>
                  <label htmlFor='full_name' className='mandatory'>Full Name</label>
                  <input id="full_name" {...register("full_name", { required: 'Fullname is required!' })} className='form-control' readOnly={true} />
                  {errors.full_name && <span className='text-danger'>{errors.full_name.message}</span>}
                </div>
                <div className='form-group'>
                  <label htmlFor='phone' className='mandatory'>Phone</label>
                  <input id="phone" {...register("phone")} className='form-control' type="text" readOnly={true} />
                </div> */}
                <div className='form-group'>
                    <label htmlFor="objective">Objective</label>
                    <textarea style={{ resize: 'none', whiteSpace: 'pre-wrap' }} id="objective" {...register("objective")} className='form-control' rows={5} disabled={false} />
                </div>
                <div className='form-group'>
                    <div style={{ marginTop: 40 }}>
                      <NavLink to={'/login'} className='href-bold-green'>Back to Login</NavLink>
                    </div>
                </div>
                <div className='form-group'>
                  <div style={{ marginTop: 40 }}>
                    <button type='submit' className='btn btn-block btn-dark btn-lg form-control'>Register</button>
                  </div>
                </div>
              </div>
              <div className='col-1'></div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
